import {
  IndustryLResponse,
  JobCountDetailResponse,
  JobTypeLResponse,
} from '@doda/api-client/aspida/@types';
import { AreaListOfSearchModal } from '@doda/common/src/models/MasterCacheModel';

/** チェックリストのインターフェース */
export interface CheckedList {
  /** 職種のチェックリスト */
  occupationCheckedList: string[];
  /** エリアのチェックリスト */
  areaCheckedList: string[];
  /** 業種のチェックリスト */
  industryCheckedList: string[];
}

/** チェック初期状態 */
export const initialCheckedList: CheckedList = {
  occupationCheckedList: [],
  areaCheckedList: [],
  industryCheckedList: [],
};

/** 表示用アイテムのインターフェース */
export interface DisplayItem {
  /** アイテムID */
  id: string;
  /** アイテム名前 */
  name: string;
  /** 件数 */
  count: number;
  /** チェックされているか */
  isChecked: boolean;
}

/** マスターアイテムのインターフェース */
interface MasterItem {
  /** アイテムID */
  id: string;
  /** アイテム名前 */
  name: string;
}

/**
 * 職種データ生成処理
 *
 * @param {JobTypeLResponse[]} masterOccupationList - マスター職種リスト
 * @returns {MasterItem[]} - 職種データ
 */
export const createOccupationList = (
  masterOccupationList: JobTypeLResponse[]
): MasterItem[] => {
  return masterOccupationList.map(({ searchJobTypeId, name }) => {
    return {
      id: searchJobTypeId,
      name,
    };
  });
};

/**
 * エリアデータ生成処理
 *
 * @param {AreaListOfSearchModal[]} masterAreaList - マスターエリアリスト
 * @returns {MasterItem[]} - エリアデータ
 */
export const createAreaList = (
  masterAreaList: AreaListOfSearchModal[]
): MasterItem[] => {
  // 全国を除外
  const filteredAreaData = masterAreaList.filter((data) => data.id !== '1');
  return filteredAreaData.map((area) => {
    let areaName = area.name;
    // 九州・沖縄を九州に変換
    if (area.name === '九州・沖縄') {
      areaName = '九州';
    }
    return {
      id: area.id,
      name: areaName,
    };
  });
};

/**
 * 業種データ生成処理
 *
 * @param {IndustryLResponse[]} masterIndustryList - マスター業種リスト
 * @returns {MasterItem[]} - 業種データ
 */
export const createIndustryList = (
  masterIndustryList: IndustryLResponse[]
): MasterItem[] => {
  return masterIndustryList.map(({ id, name }) => {
    return {
      id,
      name,
    };
  });
};

/**
 * 表示用データ生成処理
 *
 * @param {JobCountDetailResponse[]} countList - 求人件数リスト
 * @param {string[]} checkedList - チェックされたリスト
 * @param {MasterItem[]} masterList - マスターリスト
 * @returns {DisplayItem[]} - 表示用データ
 */
export const getDisplayList = (
  countList: JobCountDetailResponse[],
  checkedList: string[],
  masterList: MasterItem[]
): DisplayItem[] => {
  return masterList.map(({ id, name }) => {
    const count = countList.find((item) => id === item.id)?.count ?? 0;
    const isChecked = checkedList.some((item) => id === item);
    return {
      id,
      name,
      count,
      isChecked,
    };
  });
};
